import { NoData, HousingCard, HousingCardSkeleton } from '@/components';
import { IHousingObjectResponse, OfferType } from '@/types';
import { GridContainer } from './styles';
import { FC } from 'react';

type GridContentProps = {
  offerType: OfferType;
  objects?: IHousingObjectResponse[];
  isLoading?: boolean;
  isProject?: boolean;
};

export const GridContent: FC<GridContentProps> = ({ objects, offerType, isLoading, isProject }) => {
  if (isLoading || objects === undefined) {
    return (
      <GridContainer>
        {Array.from({ length: 6 }).map((_, i) => (
          <HousingCardSkeleton key={i} />
        ))}
      </GridContainer>
    );
  }

  return objects.length === 0 ? (
    <NoData />
  ) : (
    <GridContainer>
      {objects.map((object, index) => (
        <HousingCard
          id={`card-${object.id}`}
          key={`${object.id}`}
          data={object}
          borderless
          fromList
          offerType={offerType}
          priority={index === 0}
          cardIndex={index}
          isProject={isProject}
        />
      ))}
    </GridContainer>
  );
};
